import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../auth/AuthContext'

// Role gate, composed on top of <RequireAuth>. Unauthenticated → /login (same
// semantics as RequireAuth). Authenticated but wrong role → a clear inline
// "not authorized" panel rather than a redirect, so a seller hitting a
// mall-owner deep link understands why.
export function RequireRole({
  allow,
  children,
}: {
  allow: (role?: string | null) => boolean
  children: JSX.Element
}) {
  const { token, user } = useAuth()
  const location = useLocation()

  if (!token) return <Navigate to="/login" replace state={{ from: location }} />
  if (!allow(user?.role)) {
    return (
      <div className="empty-state">
        <h2>Not available for your account</h2>
        <p className="muted">This area is for mall owners and admins.</p>
      </div>
    )
  }
  return children
}
